import { useCallback } from "react"
import { PurchaseOrderActions } from "@finway-group/shared/lib/models/purchaseOrder/purchaseOrderStatusAction.enum"
import { useTransitionPurchaseOrderMutation } from "../queries/purchaseOrder.queries"

export const usePurchaseOrderTransition = () => {
    const transitionPurchaseOrderMutation = useTransitionPurchaseOrderMutation()

    const transitionPO = useCallback(
        async (id: string, po: { action: PurchaseOrderActions; reason?: string }) => {
            await transitionPurchaseOrderMutation.mutateAsync({ id, transition: { action: po.action, reason: po.reason } })
        },
        [transitionPurchaseOrderMutation],
    )

    return {
        transitionPO,
        isLoading: transitionPurchaseOrderMutation.isLoading,
    }
}
